<template>
    <b-card
            v-if="mode === 'view'"
            class="worker-relais-body-meeting"
    >
        <h1>
            <i class="fas fa-child"></i>
            Séance en cours
        </h1>
        <b-card class="relais-meeting-card">
            <div class="row relais-meeting-card-row">
                <div class="col-1 relais-meeting-card-col">
                    <i class="fas fa-heartbeat picto"></i>
                </div>
                <div class="col-8 relais-meeting-card-col">
                    <h2 class="text-left">
                        {{meetingType.typeActivite.name}}
                    </h2>
                    <p class="small-text">
                        {{meetingType.ou.fullName}}
                    </p>
                </div>
                <div class="col-3 relais-meeting-card-col">
                    <p>
                        <i class="fas fa-child"/>
                        {{meetingType.type}}
                    </p>
                </div>
            </div>
        </b-card>
        <div class="relais-meeting-card-buttons">
            <b-btn
                    class="relais-meeting-card-btn"
                    :to="{name: 'meeting-type', params:{id: meetingType.id}, query:{mode:'meeting'}}"
            >
                Commencer la séance
            </b-btn>
            <b-btn
                    class="relais-meeting-card-btn btn-orange"
                    :to="{name: 'relais-roadlog', query:{tab:'coaches'}}"
            >
                <i class="fas fa-comment"></i>
                Contacter un coach
            </b-btn>
        </div>
    </b-card>
    <b-card
        v-else-if="mode === 'placeholder'"
        class="worker-relais-body-meeting"
    >
        <h1>
            <i class="fas fa-child"></i>
            Séance complétée
        </h1>
        <b-card class="relais-meeting-card">
            <p class="text-center">
                Félicitations, vous avez complété votre programme de la journée.
                <br/>
            </p>
        </b-card>
        <div class="relais-meeting-card-buttons">
            <b-btn
                    class="relais-meeting-card-btn btn-orange"
                    :to="{name: 'relais-roadlog', query:{tab:'coaches'}}"
            >
                <i class="fas fa-comment"></i>
                Contacter un coach
            </b-btn>
        </div>
    </b-card>
</template>

<style lang="scss" scoped>
    .worker-relais-body-meeting{
        .card-body{
            padding: 0.2em !important;
        }
        .relais-meeting-card-row{
            padding-right: 0.3em;
        }
    }
    @media screen and (min-width: 667px) {
        .worker-relais-body-meeting{
            .relais-meeting-card-row {
                width: 97.5%;
                padding-right: 0.3em;
            }
        }
    }
</style>

<script>
    export default {
        name: 'home-middle-meeting-type',
        props: {
            meetingType: Object,
            mode: {
                default: 'view',
                type: String
            }
        }
    }
</script>
